import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";
import BestSeller from "../../homePages/components/BestSeller";
import YachtCard from "../../../../components/card/YachtCard";
import PriceRange from "./filterYacht/PriceRange";
import TravelAgent from "./filterYacht/TravelAgent";
import YachtType from "./filterYacht/YachtType";
import SelectTrip from "./filterYacht/SelectTrip";
import Malina from "./filterYacht/Malina";
import BoatHelmNorm from "../../../../Asset/icon/boat_helm.svg";
import BoatHelm from "../../../../Asset/icon/boat_helm_gray.svg";
import { useSelector, useDispatch } from "react-redux";
import { getYachtInfoSellingPriceRatePlanListDetail } from "../../../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import { getYachtInfoAmenitiesDetail } from "../../../../redux/YachtInfoAmenities/YachtInfoAmenitiesSlice";
import { getYachtInfoWaterToyDetail } from "../../../../redux/YachtInfoWaterToy/YachtInfoWaterToySlice";
import { getYachtInfoGalleryDetail } from "../../../../redux/yachtInfoGallery/YachtInfoGallerySlice";
import { getYachtInfoDestinationPackageDetail } from "../../../../redux/yachtInfoDestinationPackage/YachtInfoDestinationPackageSlice";
import { getYachtTypesDetail } from "../../../../redux/YachtTypes/YachtTypesSlice";
import {
  getMarinaDetail,
  getProvinceDetail,
  getDestinationDetail,
} from "../../../../redux/centerData/CenterDataSlice";
import { getYachtDetail } from "../../../../redux/yacht/YachtSlice";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { useParams, useLocation } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";
import "./bodyYacht.scss";
import { Pagination } from "react-bootstrap";

function BodyYacht() {
  // ดึงฟังก์ชันแปลภาษาและ parameter จาก URL
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // ดึงค่าจาก query string
  const passengers = parseInt(queryParams.get("passengers")) || 1;
  const rawDate = queryParams.get("date");

  // ดึง parameter desName, rateType, date จาก URL
  const { desName, rateType } = useParams();

  // แปลงวันที่ที่รับมาจาก slug
  let startDate = null;
  let endDate = null;
  let activityDate = null;

  if (rawDate) {
    const parts = rawDate.split("_");
    if (parts.length === 1) {
      // กรณีระบุวันเดียว
      activityDate = parts[0];
      const activityDateParts = activityDate.split("-");
      activityDate = `${activityDateParts[0]}/${String(
        parseInt(activityDateParts[1])
      ).padStart(2, "0")}/${String(parseInt(activityDateParts[2])).padStart(
        2,
        "0"
      )}`;
    } else if (parts.length === 2) {
      // กรณีระบุช่วงวันที่
      const startDateParts = parts[0].split("-");
      const endDateParts = parts[1].split("-");
      startDate = `${startDateParts[0]}/${String(
        parseInt(startDateParts[1])
      ).padStart(2, "0")}/${String(parseInt(startDateParts[2])).padStart(
        2,
        "0"
      )}`;
      endDate = `${endDateParts[0]}/${String(
        parseInt(endDateParts[1])
      ).padStart(2, "0")}/${String(parseInt(endDateParts[2])).padStart(
        2,
        "0"
      )}`;
    } else {
    }
  } else {
  }

  const yachtCardContainer = {
    boxShadow: "0px 0px 5px 2px rgba(0, 0, 0, 0.2)",
  };

  // ดึง state จาก Redux
  const todos = useSelector((state) => state);
  const dispatch = useDispatch();

  // state สำหรับจัดการ loading และ UI
  const [loading, setLoading] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 720);
  const [currentPage, setCurrentPage] = useState(1);
  const yachtsPerPage = 4;

  // ตรวจจับการเปลี่ยนขนาดหน้าจอ เพื่อเปลี่ยน layout ระหว่าง mobile/desktop
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 720);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // โหลดข้อมูลทั้งหมดเมื่อ component ถูกโหลด
  useEffect(() => {
    Promise.all([
      dispatch(getMarinaDetail({})),
      dispatch(getProvinceDetail({})),
      dispatch(getDestinationDetail({})),
      dispatch(getYachtDetail({})),
      dispatch(getYachtInfoGalleryDetail({})),
      dispatch(getYachtInfoDestinationPackageDetail({})),
      dispatch(getYachtInfoWaterToyDetail({})),
      dispatch(getYachtInfoSellingPriceRatePlanListDetail({})),
      dispatch(getYachtInfoAmenitiesDetail({})),
      dispatch(getYachtTypesDetail({})),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch]);

  function formatDateToYMD(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${year}/${month}/${day}`;
  }

  // กรองข้อมูลเรือยอชต์ตาม rateType และวันที่
  const selectedYacht = loading
    ? null
    : todos.YachtInfoSellingPriceRatePlanListSlice.YachtInfoSellingPriceRatePlanList.results.filter(
      (plan) => {
        const startPlan = formatDateToYMD(plan.start_rate_plan_date);
        const endPlan = formatDateToYMD(plan.end_rate_plan_date);
        const actDate = activityDate ? formatDateToYMD(activityDate) : null;
        const sDate = startDate ? formatDateToYMD(startDate) : null;
        const eDate = endDate ? formatDateToYMD(endDate) : null;

        // เชื่อมข้อมูล yacht ผ่าน id_yachtInfo
        const matchedYachts =
          todos.YachtInformationSlice.YachtInformation.results.filter(
            (yacht) =>
              String(yacht.id_yachtInfo) === String(plan.id_yachtInfo)
          );

        // เช็คว่ามี yacht ที่ตรงกับ id_yachtInfo หรือไม่
        if (matchedYachts.length === 0) {
          return false; // ถ้าไม่มี yacht ที่ตรงกับ id ก็จะข้ามไป
        }

        // เช็ค guestLimit กับ passengers
        const hasValidGuest = matchedYachts.some((yacht) => {
          const guests_day = parseInt(yacht?.guests_day || 0);
          const guests_sleeping = parseInt(yacht?.guests_sleeping || 0);
          const guestLimit =
            rateType === "Overnight"
              ? guests_sleeping
              : rateType === "DayTrip" || rateType === "HalfDay"
                ? guests_day
                : Infinity;

          return guestLimit >= passengers; // ถ้า guestLimit >= passengers ก็จะ return true
        });

        // กรองข้อมูลตามเงื่อนไข
        const isValidRateType = rateType ? plan.rate_type === rateType : true;

        const isInDateRange = actDate
          ? startPlan <= actDate && endPlan >= actDate
          : sDate && eDate
            ? startPlan <= sDate && endPlan >= eDate
            : true;

        // กรองสุดท้าย
        return (
          plan.rate_plan_use_in_TMY_web_site === 1 &&
          isValidRateType &&
          isInDateRange &&
          hasValidGuest
        );
      }
    );

  // รวมข้อมูลอื่น ๆ ของเรือ เช่น ชื่อมารีนา จังหวัด จุดหมายปลายทาง ฯลฯ
  const selectedYachtWithMarinaAndProvince = loading
    ? []
    : (() => {
      const selectedYachtWithAdditionalInfo = selectedYacht.map((yacht) => ({
        ...yacht,
        name_marina_en: todos.CenterDataSlice.Marina.results.find(
          (marina) => marina.id_marina === yacht.id_marina
        )?.name_marina_en,

        name_marina_th: todos.CenterDataSlice.Marina.results.find(
          (marina) => marina.id_marina === yacht.id_marina
        )?.name_marina_th,

        ProvinceEng: todos.CenterDataSlice.Province.results.find(
          (province) =>
            province.ProvinceID ===
            todos.CenterDataSlice.Marina.results.find(
              (marina) => marina.id_marina === yacht.id_marina
            )?.id_province
        )?.ProvinceEng,

        ProvinceThai: todos.CenterDataSlice.Province.results.find(
          (province) =>
            province.ProvinceID ===
            todos.CenterDataSlice.Marina.results.find(
              (marina) => marina.id_marina === yacht.id_marina
            )?.id_province
        )?.ProvinceThai,

        destinationIds:
          todos.YachtInfoDestinationPackageSlice.YachtInfoDestinationPackage.results.find(
            (desID) =>
              desID.id_destination_package === yacht.id_destination_package
          )?.destination_included,

        DestinationEng: (() => {
          const destinationIds =
            todos.YachtInfoDestinationPackageSlice.YachtInfoDestinationPackage.results.find(
              (desID) =>
                desID.id_destination_package === yacht.id_destination_package
            )?.destination_included;

          const destinationIdsArray = destinationIds
            ? destinationIds.split(",")
            : [];
          const destinationNames = destinationIdsArray.map(
            (destinationId) => {
              const destination =
                todos.CenterDataSlice.Destination.results.find(
                  (destination) =>
                    destination.id_destination === destinationId
                );
              return destination ? destination.name_destination_en : null;
            }
          );

          return destinationNames.join(",");
        })(),

        DestinationThai: (() => {
          const destinationIds =
            todos.YachtInfoDestinationPackageSlice.YachtInfoDestinationPackage.results.find(
              (desID) =>
                desID.id_destination_package === yacht.id_destination_package
            )?.destination_included;

          const destinationIdsArray = destinationIds
            ? destinationIds.split(",")
            : [];
          const destinationNames = destinationIdsArray.map(
            (destinationId) => {
              const destination =
                todos.CenterDataSlice.Destination.results.find(
                  (destination) =>
                    destination.id_destination === destinationId
                );
              return destination ? destination.name_destination_th : null;
            }
          );

          return destinationNames.join(",");
        })(),

        travelAgent: todos.YachtSlice.Yacht.results.find(
          (travelAgent) => travelAgent.id_yacht === yacht.id_yacht
        )?.name_yacht,

        travelAgentNo: todos.YachtSlice.Yacht.results.find(
          (travelAgent) => travelAgent.id_yacht === yacht.id_yacht
        )?.travel_agent_no,

        vat: todos.YachtSlice.Yacht.results.find(
          (vat) => vat.id_yacht === yacht.id_yacht
        )?.vat,

        YachtInfoAmenities:
          todos.YachtInfoAmenitiesSlice.YachtInfoAmenities.results.filter(
            (yachtInfoAmenities) =>
              yachtInfoAmenities.id_yachtInfo === yacht.id_yachtInfo
          ),

        YachtInfoWaterToy:
          todos.YachtInfoWaterToySlice.YachtInfoWaterToy.results.filter(
            (yachtInfoWaterToy) =>
              yachtInfoWaterToy.id_yachtInfo === yacht.id_yachtInfo
          ),
      }));

      // กรองด้วย desName ถ้ามีใน URL
      return selectedYachtWithAdditionalInfo.filter((yacht) => {
        if (desName) {
          return (
            yacht.ProvinceEng === desName ||
            yacht.name_marina_en === desName ||
            (yacht.DestinationEng && yacht.DestinationEng.includes(desName))
          );
        }
        return true;
      });
    })();

  // สร้างเซตสำหรับ filter dropdown ต่าง ๆ
  const marinaSet = new Set();
  const yachtAgentSet = new Set();
  const yachtTypesSet = new Set();
  const selectTripSet = new Set();

  selectedYachtWithMarinaAndProvince.forEach((yacht) => {
    marinaSet.add(yacht.name_marina_en);
  });

  selectedYachtWithMarinaAndProvince.forEach((yacht) => {
    yachtAgentSet.add(yacht.travelAgent);
  });

  selectedYachtWithMarinaAndProvince.forEach((yacht) => {
    yachtTypesSet.add(yacht.value_yachtTypes);
  });

  selectedYacht?.forEach((yacht) => {
    selectTripSet.add(yacht.rate_type);
  });

  // state สำหรับ filter ด้านหน้า
  const [filteredPriceRange, setFilteredPriceRange] = useState([0, 1000000]);
  const [selectedTravelAgents, setSelectedTravelAgents] = useState([]);
  const [selectedYachtTypes, setSelectedYachtTypes] = useState([]);
  const [selectedSelectTrip, setSelectedSelectTrip] = useState([]);
  const [selectedMalina, setSelectedMalina] = useState([]);

  // ฟังก์ชันจัดการการกรอง
  const handleMalinaFilter = (selectedMalina) => {
    setSelectedMalina(selectedMalina);
  };

  const handleYachtTypeFilter = (selectedTypes) => {
    setSelectedYachtTypes(selectedTypes);
  };

  const handleFilterYacht = (priceRange) => {
    setFilteredPriceRange(priceRange);
  };

  const handleTravelAgentFilter = (selectedAgents) => {
    setSelectedTravelAgents(selectedAgents);
  };

  const handleSelectTripFilter = (selectedTrip) => {
    setSelectedSelectTrip(selectedTrip);
  };

  // วันที่ปัจจุบัน
  const today = new Date();

  // กรองข้อมูลเรือที่ตรงกับ filter ที่ผู้ใช้เลือกไว้ + อยู่ในช่วงวันที่เปิดให้แสดง
  const filteredYachtData = selectedYachtWithMarinaAndProvince.filter(
    (yacht) => {
      // แปลงจาก "2025/10/16" -> "2025-10-16" ก่อน
      const startDate = yacht.start_rate_plan_date
        ? new Date(yacht.start_rate_plan_date.replace(/\//g, "-"))
        : null;
      const endDate = yacht.end_rate_plan_date
        ? new Date(yacht.end_rate_plan_date.replace(/\//g, "-"))
        : null;

      // ตรวจสอบวันที่ว่าปัจจุบันอยู่ในช่วงหรือไม่
      const isWithinDateRange =
        (!startDate || today >= startDate) && (!endDate || today <= endDate);

      return (
        yacht.name_marina_en &&
        yacht.value_sellingPrice >= filteredPriceRange[0] &&
        yacht.value_sellingPrice <= filteredPriceRange[1] &&
        (selectedTravelAgents.length === 0 ||
          selectedTravelAgents.includes(yacht.travelAgent)) &&
        (selectedYachtTypes.length === 0 ||
          selectedYachtTypes.includes(yacht.value_yachtTypes)) &&
        (selectedMalina.length === 0 ||
          selectedMalina.includes(yacht.name_marina_en)) &&
        (selectedSelectTrip.length === 0 ||
          selectedSelectTrip.includes(yacht.rate_type)) &&
        isWithinDateRange // ✅ เงื่อนไขวันที่
      );
    }
  );

  // ดึงภาษาใน localStorage
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  // จัดการ dropdown คลิกนอก popup แล้วปิด
  const popupRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupRef]);

  // รวมข้อมูลเรือแบบไม่ซ้ำ โดยหาต่ำสุดของราคาและรวมจุดหมายปลายทาง
  const uniqueYachts = filteredYachtData.reduce((uniqueYachts, yacht) => {
    const existingYacht = uniqueYachts.find(
      (uniqueYacht) => uniqueYacht.id_yachtInfo === yacht.id_yachtInfo
    );

    if (!existingYacht) {
      const destinationsEng = filteredYachtData
        .filter((y) => y.id_yachtInfo === yacht.id_yachtInfo)
        .map((y) => y.DestinationEng)
        .filter(
          (destination, index, self) => self.indexOf(destination) === index
        )
        .join(", ");

      const destinationsThai = filteredYachtData
        .filter((y) => y.id_yachtInfo === yacht.id_yachtInfo)
        .map((y) => y.DestinationThai)
        .filter(
          (destination, index, self) => self.indexOf(destination) === index
        )
        .join(", ");

      const lowestPrice = Math.min(
        ...filteredYachtData
          .filter((y) => y.id_yachtInfo === yacht.id_yachtInfo)
          .map((y) => y.value_sellingPrice)
      );

      uniqueYachts.push({
        ...yacht,
        destinations: { eng: destinationsEng, thai: destinationsThai },
        lowestPrice: lowestPrice,
      });
    }

    return uniqueYachts;
  }, []);

  const indexOfLastYacht = currentPage * yachtsPerPage;
  const indexOfFirstYacht = indexOfLastYacht - yachtsPerPage;
  const currentYachts = filteredYachtData.slice(
    indexOfFirstYacht,
    indexOfLastYacht
  );
  const totalPages = Math.ceil(filteredYachtData.length / yachtsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };

  return (
    <div className="container mt-5vh">
      <div className="row align-items-stretch">
        {/* <div className="col-lg-1 order-md-2 d-none d-lg-block"></div> */}
        <div className="col-lg-3 text-center order-md-1 col-md-12 mb-4">
          <div className="row justify-content-center">
            {loading ? null : (
              <div className="col-12 col-md-8 col-xs-12">
                {isMobile ? (
                  <>
                    <img
                      className="BoatHelm-1"
                      draggable={false}
                      src={BoatHelmNorm}
                      alt="BoatHelm"
                    />
                    <h2 className="justify-center">
                      {t("Yacht lists")}
                    </h2>
                    <button
                      className="filter-button"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                      {t("Filters")}
                    </button>
                    {isDropdownOpen && (
                      <>
                        <div ref={popupRef} className="popup-content">
                          {todos.CenterDataSlice.Marina.results &&
                            todos.CenterDataSlice.Marina.results.length > 0 ? (
                            <div>
                              <PriceRange
                                setPriceRange={handleFilterYacht}
                                filterYacht={handleFilterYacht}
                              />

                              <Malina
                                malinaData={todos.CenterDataSlice.Marina.results.map(
                                  (marina) => marina.name_marina_en //add fitler on this!!
                                )}
                                setMalinaFilter={handleMalinaFilter}
                                preMarina={marinaSet}
                              />

                              <TravelAgent
                                travelAgents={todos.YachtSlice.Yacht.results.map(
                                  (yacht) => yacht.name_yacht
                                )}
                                setTravelAgentFilter={handleTravelAgentFilter}
                                // clearTravelAgentFilter={clearTravelAgentFilter}
                                preYachtAgent={yachtAgentSet}
                              />
                              <YachtType
                                yachtTypes={todos.YachtTypesSlice.YachtTypes.results.map(
                                  (type) => type.yacht_types
                                )}
                                setYachtTypeFilter={handleYachtTypeFilter}
                                preYachtTypes={yachtTypesSet}
                              />

                              <SelectTrip
                                selectTrips={todos.YachtInfoSellingPriceRatePlanListSlice.YachtInfoSellingPriceRatePlanList.results.map(
                                  (trip) => trip.rate_type
                                )}
                                setSelectTripFilter={handleSelectTripFilter}
                                preSelectTrip={selectTripSet}
                              />
                            </div>
                          ) : (
                            <div>{t("No marinas available")}</div>
                          )}
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <div>
                    {todos.CenterDataSlice.Marina.results &&
                      todos.CenterDataSlice.Marina.results.length > 0 ? (
                      <div>
                        <PriceRange
                          setPriceRange={handleFilterYacht}
                          filterYacht={handleFilterYacht}
                        />

                        <Malina
                          malinaData={todos.CenterDataSlice.Marina.results.map(
                            (marina) => marina.name_marina_en
                          )}
                          setMalinaFilter={handleMalinaFilter}
                          preMarina={marinaSet}
                        />

                        <TravelAgent
                          travelAgents={todos.YachtSlice.Yacht.results.map(
                            (yacht) => yacht.name_yacht
                          )}
                          setTravelAgentFilter={handleTravelAgentFilter}
                          // clearTravelAgentFilter={clearTravelAgentFilter}
                          preYachtAgent={yachtAgentSet}
                        />
                        <YachtType
                          yachtTypes={todos.YachtTypesSlice.YachtTypes.results.map(
                            (type) => type.yacht_types
                          )}
                          setYachtTypeFilter={handleYachtTypeFilter}
                          preYachtTypes={yachtTypesSet}
                        />

                        <SelectTrip
                          selectTrips={todos.YachtInfoSellingPriceRatePlanListSlice.YachtInfoSellingPriceRatePlanList.results.map(
                            (trip) => trip.rate_type
                          )}
                          setSelectTripFilter={handleSelectTripFilter}
                          preSelectTrip={selectTripSet}
                        />
                      </div>
                    ) : (
                      <div>{t("No marinas available")}</div>
                    )}
                  </div>
                )}
                {/* <div className="col-lg-12 text-center order-md-5 order-mb-5 col-md-12 mb-6">
                  <TopDestinationMultiRow />
                </div> */}
              </div>
            )}
          </div>
        </div>

        {/* <div div className="col-lg-1 order-md-2 d-none d-lg-block"></div> */}

        <div className="col-lg-8 order-md-2 col-md-12 mb-4">
          {loading ? null : selectedYachtWithMarinaAndProvince.length === 0 ? (
            <div
              className="modal-content3"
            >
              <div
                className="flex-column-center"
              >
                <img
                  draggable={false}
                  src={BoatHelm}
                  alt="BoatHelm"
                  className="logo-image"
                />
                <h2 className="text-gray-small">
                  "{t("No yachts available")}"
                </h2>
              </div>
            </div>
          ) : (
            <>
              {currentYachts.map((item, index) => (
                <Link
                  to={`/yacht/detailYacht/${item.id_sellingPrice}`}
                  key={index}
                >
                  <YachtCard
                    headline={item.name_yacht_yachtInfo}
                    image={item.logo_yachtInfo_url}
                    marina={
                      selectedLanguage === "en"
                        ? item.name_marina_en
                        : item.name_marina_th
                    }
                    province={
                      selectedLanguage === "en"
                        ? item.ProvinceEng
                        : item.ProvinceThai
                    }
                    travelAgent={item.travelAgent}
                    travelNO={item.travelAgentNo}
                    vat={item.vat}
                    dayOption={item.rate_type}
                    destination={
                      selectedLanguage === "en"
                        ? item.DestinationEng
                        : item.DestinationThai
                    }
                    price={item.value_sellingPrice}
                    cruising_speed={item.cruising_speed}
                    guests_day={item.guests_day}
                    guests_sleeping={item.guests_sleeping}
                    amenities={item.YachtInfoAmenities}
                    waterToy={item.YachtInfoWaterToy}
                    style={yachtCardContainer}
                  />
                </Link>
              ))}

              {/* Pagination Controls */}
              {totalPages > 1 && (
                <div
                  className="flex-center-mt30"
                >
                  <Pagination className="d-flex justify-content-center circular-pagination">
                    <Pagination.Item
                      className="prev"
                      onClick={handlePreviousPage}
                      disabled={currentPage === 1}
                    >
                      &lt;
                    </Pagination.Item>

                    {Array.from({ length: totalPages }, (_, index) => index + 1)
                      .filter((number) => {
                        return (
                          number === 1 ||
                          number === totalPages ||
                          (number >= currentPage - 1 &&
                            number <= currentPage + 1)
                        );
                      })
                      .reduce((acc, number, idx, arr) => {
                        if (idx > 0 && number - arr[idx - 1] > 1) {
                          acc.push("ellipsis");
                        }
                        acc.push(number);
                        return acc;
                      }, [])
                      .map((item, idx) =>
                        item === "ellipsis" ? (
                          <Pagination.Ellipsis
                            key={`ellipsis-${idx}`}
                            disabled
                          />
                        ) : (
                          <Pagination.Item
                            key={item}
                            active={item === currentPage}
                            onClick={() => handlePageChange(item)}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      )}

                    <Pagination.Item
                      className="next"
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                    >
                      &gt;
                    </Pagination.Item>
                  </Pagination>
                </div>
              )}
            </>
          )}
        </div>
        <div className="col-lg-1 order-md-4 d-none d-lg-block"></div>
        <div className="col-lg-12 text-center order-md-4 col-md-12 mb-4">
          <BestSeller />
        </div>
      </div>
    </div>
  );
}

export default BodyYacht;
